import script from "./ResetPasswordModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ResetPasswordModal.vue?vue&type=script&setup=true&lang=js"

import "./ResetPasswordModal.vue?vue&type=style&index=0&id=817648e2&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-817648e2"]])

export default __exports__